import React from "react";

/**
 * Bhega badge — the signature ✊ raised-fist unity counter.
 * `tone` controls visual emphasis: 'solid' (yellow filled - primary CTA), 'soft' (subtle), 'ghost' (text-only).
 */
export default function BhegaBadge({ count = 0, tone = "soft", size = "md", testId }) {
  const sizeMap = {
    sm: "text-xs px-2 py-0.5 gap-1",
    md: "text-xs px-2.5 py-1 gap-1.5",
    lg: "text-sm px-3 py-1.5 gap-2",
  };
  const toneMap = {
    solid: "bg-[#FFBE06] text-black shadow-sm border border-[#E5A900]",
    soft: "bg-[#FFBE06]/15 text-brand border border-[#FFBE06]/40",
    ghost: "bg-transparent text-foreground",
    dark: "bg-card text-brand border border-border",
  };
  return (
    <span
      className={`inline-flex items-center font-bold rounded-full ${sizeMap[size]} ${toneMap[tone]} transition-transform hover:scale-[1.04]`}
      data-testid={testId}
      title={`${count} buyers united (Bhega)`}
    >
      <span className="text-base leading-none" aria-hidden>✊</span>
      <span>
        <strong className="font-heading">{count}</strong>{" "}
        <span className="font-semibold tracking-wide">Bhega</span>
      </span>
    </span>
  );
}
